import {useEffect, useState} from 'react'
import {MenuComponent} from '../../../../../../../../_metronic/assets/ts/components'
import {initialQueryState, KTSVG} from '../../../../../../../../_metronic/helpers'
import {useQueryRequest} from '../../core/QueryRequestProvider'
import {useIntl} from 'react-intl'
import axios from 'axios'
import AsyncSelect from 'react-select/async'
import {colourStyles} from '../../../styles/styles'
interface UseOption {
  readonly value: string
  readonly label: string
}

const IndemnityItemsListFilter = () => {
  const intl = useIntl()
  const initSelect = {
    value: '',
    label: intl.formatMessage({id: 'COMMON.ALL'}),
  }
  const {updateState} = useQueryRequest()

  //variaval de controle do filtro avançado
  const [openFilterWin, setOpenFilterWin] = useState<boolean>(false)

  // variaveis do filtro
  //inicio variaveis que usam AsyncSelect
  const [project_obj, setproject_obj] = useState<any | undefined>()
  const [project_id, setproject_id] = useState<string | undefined>()

  const [license_type_id, setlicense_type_id] = useState<string | undefined>()
  const [license_type_id_obj, setlicense_type_id_obj] = useState<any | undefined>()
  //fim variaveis que usam AsyncSelect

  //variaveis normais
  const [name, setname] = useState<string | undefined>()
  const [reference_month, setreference_month] = useState<string | undefined>()
  const [direct_damage_value, setdirect_damage_value] = useState<string | undefined>()
  const [outgoing_profit_value, setoutgoing_profit_value] = useState<string | undefined>()
  const [single_payment_value, setsingle_payment_value] = useState<string | undefined>()

  const API_URL = process.env.REACT_APP_API_URL || 'api'

  useEffect(() => {
    MenuComponent.reinitialization()
  }, [])

  // função que reseta os filtros
  const resetData = () => {
    updateState({filter: undefined, ...initialQueryState})

    setproject_id(undefined)
    setproject_obj(initSelect)
    setlicense_type_id(undefined)
    setlicense_type_id_obj(initSelect)
    setname(undefined)
    setreference_month(undefined)
    setdirect_damage_value(undefined)
    setoutgoing_profit_value(undefined)
    setsingle_payment_value(undefined)
  }

  // função que faz a busca dos dados
  const filterData = () => {
    updateState({
      filter: {
        project_id,
        license_type_id,
        name,
        reference_month,
        direct_damage_value,
        outgoing_profit_value,
        single_payment_value,
      },
      ...initialQueryState,
    })
  }

  // função que abre o filtro avançado
  const openFilter = () => {
    if (openFilterWin === false) {
      setOpenFilterWin(true)
    } else {
      setOpenFilterWin(false)
    }
  }

  //função que busca os dados do projeto do AsyncSelect
  const loadOptionsProjects = (inputValue: string, callback: (options: UseOption[]) => void) => {
    setTimeout(() => {
      getProjects()
      var projects: any = []
      async function getProjects() {
        const {data} = await axios.get(API_URL + '/v1/projects/select2')
        let Response = data.results

        const projectInit: any = {
          value: '',
          label: intl.formatMessage({id: 'COMMON.ALL'}),
        }
        projects.push(projectInit)

        if (Response) {
          for (var i = 0; i < Response.length; i++) {
            const project: any = {
              value: Response[i].id,
              label: Response[i].code,
            }
            projects.push(project)
          }
        }
      }
      callback(projects)
    }, 1000)
  }

  //função que altera o valor do projeto no AsyncSelect
  const handleChangeProject = (option: any) => {
    setproject_id(option.value)
    setproject_obj(option)
  }

  //função que busca os dados do tipo de licença do AsyncSelect
  const loadOptionsLicenses_Types = (
    inputValue: string,
    callback: (options: UseOption[]) => void
  ) => {
    setTimeout(() => {
      getlicenses_Types()
      var licenses: any = []
      async function getlicenses_Types() {
        const {data} = await axios.get(API_URL + '/v1/measurement_units/select2')
        let Response = data.results

        const licenseInit: any = {
          value: '',
          label: intl.formatMessage({id: 'COMMON.ALL'}),
        }
        licenses.push(licenseInit)

        for (var i = 0; i < Response.length; i++) {
          const license: any = {
            value: Response[i].id,
            label: Response[i].abbreviation,
          }

          licenses.push(license)
        }
      }
      callback(licenses)
    }, 1000)
  }

  //função que altera o valor do tipo de licença no AsyncSelect
  const handleChangeLicenseType = (option: any) => {
    setlicense_type_id(option.value)
    setlicense_type_id_obj(option)
  }

  return (
    <>
      <div className='card-body pt-0 '>
        {/* INICIO LINHA FIXA DO FILTRO */}
        <div className='row'>
          <div className='col-lg-4'>
            <label className='form-label fs-7 fw-bold'>
              {intl.formatMessage({id: 'PROJECT.PROJECT_TITLE'})}
            </label>
            <div className='d-flex align-items-center position-relative my-1'>
              <AsyncSelect
                className='form-control form-control-solid fs-7 p-1 ps-3'
                data-kt-license-table-filter='project_id'
                styles={colourStyles}
                cacheOptions
                loadOptions={loadOptionsProjects}
                onChange={(e: any) => handleChangeProject(e)}
                value={project_obj}
                filterOption={(option, inputValue) =>
                  option.label
                    ? option.label.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
                    : false
                }
                defaultOptions
                placeholder={
                  intl.formatMessage({id: 'COMMON.SEARCH'}) +
                  ' ' +
                  intl.formatMessage({id: 'PROJECT.PROJECT_TITLE'})
                }
              />
            </div>
          </div>

          {/* inicio filtro de nome */}
          <div className='col-lg-3'>
            <label className='form-label fs-7 fw-bold'>
              {intl.formatMessage({id: 'COMMON.INPUT_NAME'})}
            </label>
            <div className='d-flex align-items-center position-relative my-1'>
              <input
                type='text'
                data-kt-user-table-filter='responsible'
                className='form-control form-control-solid fs-7 ps-6'
                placeholder={
                  intl.formatMessage({id: 'COMMON.SEARCH'}) +
                  ' ' +
                  intl.formatMessage({id: 'COMMON.INPUT_NAME'})
                }
                onChange={(e: any) => setname(e.target.value)}
                value={name}
              />
            </div>
          </div>

          {/* filtro de unidade de medida  */}
          <div className='col-lg-5'>
            <label className='form-label fs-7 fw-bold'>
              {intl.formatMessage({id: 'MEASUREMENT.TITLE'})}
            </label>
            <div className='d-flex align-items-center position-relative my-1'>
              <AsyncSelect
                className='form-control form-control-solid fs-7 p-1 ps-3'
                data-kt-license-table-filter='measurement_unit_id'
                styles={colourStyles}
                cacheOptions
                loadOptions={loadOptionsLicenses_Types}
                filterOption={(option, inputValue) =>
                  option.label
                    ? option.label.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
                    : false
                }
                defaultOptions
                placeholder={
                  // eslint-disable-next-line
                  intl.formatMessage({id: 'COMMON.SEARCH'}) +
                  ' ' +
                  intl.formatMessage({id: 'MEASUREMENT.TITLE'})
                }
                onChange={(e: any) => handleChangeLicenseType(e)}
                value={license_type_id_obj}
              />
              <button
                type='button'
                className='btn btn-sm btn-icon btn-light-primary btn-active-primary p-3 m-1'
                onClick={openFilter}
                title='Mais Filtros'
              >
                <i className='bi bi-sliders2-vertical fs-2' />
              </button>
              <button
                type='button'
                className='btn btn-sm btn-icon btn-light-danger p-3 m-1'
                onClick={resetData}
                title='Limpar'
              >
                <KTSVG path='/media/icons/duotune/art/art004.svg' className='svg-icon-3' />
              </button>
              <button
                type='button'
                className='btn btn-sm btn-primary m-1'
                onClick={filterData}
                title='Filtar'
              >
                {intl.formatMessage({id: 'COMMON.SEARCH'})}
              </button>
            </div>
          </div>
        </div>

        {/* FIM LINHA 1 FIXA DO FILTRO */}

        {/* INICIO FILTRO RETRATIL FIXA DO FILTRO */}

        {/*INICIO LINHA 2 */}
        {openFilterWin && (
          <div className='row mt-2'>
            {/* filtro de mes de referencia */}
            <div className='col-lg-3'>
              <label className='form-label fs-7 fw-bold'>
                {intl.formatMessage({id: 'INDEMNITY_ITEM.REFERECE_MONTH'})}
              </label>
              <div className='d-flex align-items-center position-relative my-1'>
                <input
                  type='text'
                  data-kt-user-table-filter='reference_month'
                  className='form-control form-control-solid fs-7  ps-6'
                  placeholder={
                    intl.formatMessage({id: 'COMMON.SEARCH'}) +
                    ' ' +
                    intl.formatMessage({id: 'INDEMNITY_ITEM.REFERECE_MONTH'})
                  }
                  onChange={(e: any) => setreference_month(e.target.value)}
                  value={reference_month}
                />
              </div>
            </div>

            {/* inicio filtro de valor de dano direto */}
            <div className='col-lg-3'>
              <label className='form-label fs-7 fw-bold'>
                {intl.formatMessage({id: 'INDEMNITY_ITEM.DIRECT_DAMAGE_VALUE'})}
              </label>
              <div className='d-flex align-items-center position-relative my-1'>
                <input
                  type='text'
                  data-kt-user-table-filter='direct_damage_value'
                  className='form-control form-control-solid fs-7 ps-6'
                  placeholder={
                    intl.formatMessage({id: 'COMMON.SEARCH'}) +
                    ' ' +
                    intl.formatMessage({id: 'INDEMNITY_ITEM.DIRECT_DAMAGE_VALUE'})
                  }
                  onChange={(e: any) => setdirect_damage_value(e.target.value)}
                  value={direct_damage_value}
                />
              </div>
            </div>

            {/* inicio filtro de valor lucro cessante */}
            <div className='col-lg-3'>
              <label className='form-label fs-7 fw-bold'>
                {intl.formatMessage({id: 'INDEMNITY_ITEM.OUTGOING_PROFIT_VALUE'})}
              </label>
              <div className='d-flex align-items-center position-relative my-1'>
                <input
                  type='text'
                  data-kt-user-table-filter='outgoing_profit_value'
                  className='form-control form-control-solid fs-7 ps-6'
                  placeholder={
                    intl.formatMessage({id: 'COMMON.SEARCH'}) +
                    ' ' +
                    intl.formatMessage({id: 'INDEMNITY_ITEM.OUTGOING_PROFIT_VALUE'})
                  }
                  onChange={(e: any) => setoutgoing_profit_value(e.target.value)}
                  value={outgoing_profit_value}
                />
              </div>
            </div>

            {/* inicio filtro de valor de pagamento unico */}
            <div className='col-lg-3'>
              <label className='form-label fs-7 fw-bold'>
                {intl.formatMessage({id: 'INDEMNITY_ITEM.SINGLE_PAYMENT_VALUE'})}
              </label>
              <div className='d-flex align-items-center position-relative my-1'>
                <input
                  type='text'
                  data-kt-user-table-filter='single_payment_value'
                  className='form-control form-control-solid fs-7 ps-6'
                  placeholder={
                    intl.formatMessage({id: 'COMMON.SEARCH'}) +
                    ' ' +
                    intl.formatMessage({id: 'INDEMNITY_ITEM.SINGLE_PAYMENT_VALUE'})
                  }
                  onChange={(e: any) => setsingle_payment_value(e.target.value)}
                  value={single_payment_value}
                />
              </div>
            </div>
          </div>
        )}
        {/* FIM LINHA 3 */}
      </div>
    </>
  )
}

export {IndemnityItemsListFilter}
